import { render, staticRenderFns } from "./CalendarFooter.vue?vue&type=template&id=35ce188a&"
import script from "./CalendarFooter.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarFooter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports